import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ChildSelector from '../../components/parent/ChildSelector';
import { useParentChild } from '../../contexts/ParentChildContext';
import api from '../../services/api';

const ParentAbsencesPage = () => {
  const { inscriptionId } = useParentChild();
  const [absences, setAbsences] = useState([]);
  const [periodes, setPeriodes] = useState([]);
  const [periodeId, setPeriodeId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inscriptionId) return;
    api.get(`/parent-portal/children/${inscriptionId}/periodes`)
      .then((res) => { if (res.data.success) setPeriodes(res.data.data); })
      .catch(() => {});
  }, [inscriptionId]);

  useEffect(() => {
    if (!inscriptionId) return;
    setLoading(true);
    const params = periodeId ? { periode_id: periodeId } : {};
    api.get(`/parent-portal/children/${inscriptionId}/absences`, { params })
      .then((res) => { if (res.data.success) setAbsences(res.data.data); })
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  }, [inscriptionId, periodeId]);

  return (
    <div className="space-y-4">
      <ChildSelector />
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-slate-900">Absences</h2>
          <p className="text-sm text-slate-500">Historique des absences de votre enfant</p>
        </div>
        {periodes.length > 0 && (
          <select
            value={periodeId}
            onChange={(e) => setPeriodeId(e.target.value)}
            className="rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white"
          >
            <option value="">Toutes les périodes</option>
            {periodes.map((p) => (
              <option key={p.id} value={p.id}>{p.periode}</option>
            ))}
          </select>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="animate-spin w-6 h-6 border-2 border-primary-600 border-t-transparent rounded-full" />
        </div>
      ) : absences.length === 0 ? (
        <div className="bg-white rounded-xl p-8 text-center text-slate-500">Aucune absence enregistrée</div>
      ) : (
        <div className="space-y-3">
          {absences.map((a) => (
            <div key={a.id} className="bg-white rounded-xl border border-slate-200 p-4">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-medium text-slate-900">
                    {a.date_absence ? new Date(a.date_absence).toLocaleDateString('fr-FR') : '—'}
                  </p>
                  <p className="text-sm text-slate-500">
                    {a.incident_designation || 'Absence'}
                    {a.periode ? ` — ${a.periode}` : ''}
                  </p>
                  {a.motif && <p className="text-xs text-slate-400 mt-1">{a.motif}</p>}
                </div>
                <div className="text-right">
                  {a.journee_entiere === 'Y' && (
                    <span className="text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full">Journée entière</span>
                  )}
                  {a.retrait > 0 && (
                    <p className="text-xs text-red-500 mt-1">-{a.retrait} pt(s)</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentAbsencesPage;
